import { userUrl } from "common/constants/apiUrls";
import { updateData } from "networkManager/NetworkManager";

export const updatePassword = async (payload) => {
    return await updateData(userUrl.changePassword, payload);
};
